module.exports = __webpack_public_path__ + "img/cog_finder.b9e55119.jpg";